<template>
  <v-app>
    <div class="maincontainer">
      <h2 class="title mt-12">認証コードの入力</h2>
      <div v-if="isLoading" class="loading-overlay">
        <div class="loading-message">ローディング中<span class="dots">...</span></div>
      </div>
      <div class="mt-12">
        <p class="description">
          ご登録のメールアドレス宛に＜認証コード＞が送信されました。<br />届いたメールの本文に記載されている４桁の認証コードをご入力ください。
        </p>
      </div>
      <div class="mt-5 mailaddress">認証コード</div>
      <v-text-field
        class="ml-10 mr-10"
        v-model="pin"
        :rules="pinRules"
        density="compact"
        required
        @input="unshowError"
      />
      <div>
        <v-btn
          class="mt-5"
          height="35"
          width="130"
          rounded="pill"
          @click="submit"
          color="rgb(237, 121, 149)"
          :disabled="!pin || pin.length !== 4"
        >
          <a class="login">認証を完了する</a>
        </v-btn>
      </div>
      <div>
        <p class="mt-4 resend" @click="resendEmail">▶︎認証メールを再送信する</p>
      </div>
      <div v-if="flagmessage" class="textmessage mt-5">
        <p>認証コードを再送信しました。</p>
      </div>
      <div v-if="error" class="textmessage mt-5">
        <p>認証コードの再送信に失敗しました。</p>
      </div>
      <div v-if="pinerror" class="textmessage mt-5">
        <p>認証コードが間違っております。メールを確認の上、再度ご入力ください。</p>
      </div>
    </div>
  </v-app>
</template>

<script setup>
import { ref } from "vue";
import { getFunctions, httpsCallable } from "firebase/functions";

const pin = ref("");
const flagmessage = ref(false);
const error = ref(false);
const pinerror = ref(false);
const isLoading = ref(false);

const pinRules = [
  (v) => !!v || "認証コードを入力してください",
  (v) => (v && v.length === 4) || "認証コードは4桁で入力してください",
];

const submit = async () => {
  isLoading.value = true;
  if (pin.value.length === 4) {
    console.log(pin.value);
    const functions = getFunctions(undefined, "asia-northeast1");
    const commonCheckPin = httpsCallable(functions, "Common_checkPin");

    try {
      const result = await commonCheckPin({ pinFromFront: pin.value });
      console.log(result.data); // 結果は `data` プロパティに格納されています
      if (result.data.text === "成功した") {
        isLoading.value = false;
        console.log("成功した");
        const routeTo = "/twofactorauthenticationdone";
        window.location.href = routeTo;
      } else if (result.data.text === "失敗した") {
        isLoading.value = false;
        flagmessage.value = false;
        pinerror.value = true;
      }
    } catch (error) {
      console.error("Error calling function:", error);
      flagmessage.value = false;
      pinerror.value = true;
      isLoading.value = false;
    }
    // window.location.href = "/login";
  }
};

// メール再送信処理の関数
const resendEmail = async () => {
  pinerror.value = false;
  isLoading.value = true;
  console.log("メールを再送信します。");
  // ここにメールを再送信するためのロジックを追加
  const functions = getFunctions(undefined, "asia-northeast1");
  const confirmMail = httpsCallable(functions, "Common_confirmMail");

  try {
    const result = await confirmMail({});
    console.log(result.data); // 結果は `data` プロパティに格納されています
    if (result.data.text === "成功した") {
      isLoading.value = false;
      flagmessage.value = true;
    } else if (result.data.text === "失敗した") {
      isLoading.value = false;
      error.value = true;
    }
  } catch (error) {
    isLoading.value = false;
    console.error("Error calling function:", error);
  }
};

const unshowError = () => {
  error.value = false;
  pinerror.value = false;
  flagmessage.value = false;
};
</script>

<style scoped>
.maincontainer {
  margin: 0 0 50px 0;
}
.title {
  font-size: 14px;
}
.mailaddress {
  font-size: 12px;
  text-align: left;
  margin-left: 40px;
}
.login {
  color: rgb(255 255 255);
  font-size: 12px;
}
.resend {
  cursor: pointer;
}
.textmessage {
  color: red;
  margin: auto;
  width: 300px;
}
.loading-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
}
.loading-message {
  color: white;
  font-size: 20px;
}
.loading-circle {
  width: 50px;
  height: 50px;
}

/*スマートフォン-----------------------------------------------------------------------------------*/
@media only screen and (max-width: 1000px) {
  .description {
    margin: 0 20px;
  }
}
</style>
